<template>
    <el-menu
        class="navigation"
        :router="false"
        :default-openeds="openedSubMenu"
        @open="handleOpen"
        @close="handleClose"
    >
        <el-submenu
            index="/tasks"
            :route="{name:'tasks'}"
            v-if="canView('tasks')"
            :class="{ 'is-active-item': nameSection === 'tasks'}"
        >
            <template slot="title">
                <div class="menu-icon-wrapper">
                    <font-awesome-icon icon="tasks" class="menu-icon" />
                </div>
                <el-badge :value="taskMetrics.all" class="menu-metric" :hidden="!isShownTaskParentMenuItemMetric">
                    <span class="submenu">
                        Задачи
                    </span>
                </el-badge>
            </template>
            <el-menu-item
                index="/tasks/all"
                :class="['sub', { 'is-active-item': currentRouteName === 'tasks-all'}]"
                @click="routeAndMobileMenuClose({ name:'tasks-all' })"
            >
                <a :href="this.$router.resolve({ name:'tasks-all' }).href">
                    <el-badge :value="taskMetrics.all" class="menu-metric" :hidden="isShownTaskParentMenuItemMetric">
                        <span>Все</span>
                    </el-badge>
                </a>
            </el-menu-item>
            <el-menu-item
                index="/tasks/overdue"
                :class="['sub', { 'is-active-item': currentRouteName === 'tasks-overdue'}]"
                @click="routeAndMobileMenuClose({ name:'tasks-overdue' })"
            >
                <a :href="this.$router.resolve({ name:'tasks-overdue' }).href">
                    <el-badge :value="taskMetrics.overdue" class="menu-metric" :hidden="isShownTaskParentMenuItemMetric">
                        <span>Просроченные</span>
                    </el-badge>
                </a>
            </el-menu-item>
            <el-menu-item
                index="/tasks/today"
                :class="['sub', { 'is-active-item': currentRouteName === 'tasks-today'}]"
                @click="routeAndMobileMenuClose({ name:'tasks-today' })"
            >
                <a :href="this.$router.resolve({ name:'tasks-today' }).href">
                    <el-badge :value="taskMetrics.today" class="menu-metric" :hidden="isShownTaskParentMenuItemMetric">
                        <span>Сегодня</span>
                    </el-badge>
                </a>
            </el-menu-item>
            <el-menu-item
                index="/tasks/tomorrow"
                :class="['sub', { 'is-active-item': currentRouteName === 'tasks-tomorrow'}]"
                @click="routeAndMobileMenuClose({ name:'tasks-tomorrow' })"
            >
                <a :href="this.$router.resolve({ name:'tasks-tomorrow' }).href">
                    <el-badge :value="taskMetrics.tomorrow" class="menu-metric" :hidden="isShownTaskParentMenuItemMetric">
                        <span>Завтра</span>
                    </el-badge>
                </a>
            </el-menu-item>
            <el-menu-item
                index="/tasks/timeless"
                :class="['sub', { 'is-active-item': currentRouteName === 'tasks-timeless'}]"
                @click="routeAndMobileMenuClose({ name:'tasks-timeless' })"
            >
                <a :href="this.$router.resolve({ name:'tasks-timeless' }).href">
                    <el-badge :value="taskMetrics.timeless" class="menu-metric" :hidden="isShownTaskParentMenuItemMetric">
                        <span>Без срока</span>
                    </el-badge>
                </a>
            </el-menu-item>
        </el-submenu>
        <el-submenu
            index="/crm"
            :route="{name:'crm'}"
            v-if="canView('crm')"
            :class="{ 'is-active-item': nameSection === 'crm'}"
        >
            <template slot="title">
                <div class="menu-icon-wrapper">
                    <font-awesome-icon :icon="['far', 'window-maximize']" class="menu-icon" />
                </div>
                <span class="submenu">
                    CRM
                </span>
            </template>
            <el-menu-item
                index="/crm/contacts"
                v-if="canView('companies')"
                :class="['sub', { 'is-active-item': currentRouteName === 'contacts'}]"
                @click="routeAndMobileMenuClose({ name:'contacts' })"
            >
                <a :href="this.$router.resolve({ name:'contacts' }).href">
                    <span>Контакты</span>
                </a>
            </el-menu-item>
            <el-menu-item
                index="/crm/leads"
                v-if="canView('leads')"
                :class="['sub', { 'is-active-item': currentRouteName === 'leads' || currentRouteName === 'lead-card'}]"
                @click="routeAndMobileMenuClose({ name:'leads' })"
            >
                <a :href="this.$router.resolve({ name:'leads' }).href">
                    <el-badge :value="leadMetric" class="menu-metric">
                        <span>Лиды</span>
                    </el-badge>
                </a>
            </el-menu-item>
            <el-menu-item
                index="/crm/deals"
                v-if="canView('deals')"
                :class="['sub', { 'is-active-item': currentRouteName === 'deals' || currentRouteName === 'deal-card'}]"
                @click="routeAndMobileMenuClose({ name:'deals' })"
            >
                <a :href="this.$router.resolve({ name:'deals' }).href">
                    <span>Сделки</span>
                </a>
            </el-menu-item>
        </el-submenu>
        <el-submenu
            index="/finance"
            :route="{name:'finance'}"
            v-if="canView('finance')"
            :class="{ 'is-active-item': nameSection === 'finance'}"
        >
            <template slot="title">
                <div class="menu-icon-wrapper">
                    <font-awesome-icon icon="file-invoice-dollar" class="menu-icon" />
                </div>
                <span class="submenu">
                    Финансы
                </span>
                <template v-if="isShownFinanceMenuItemMetric">
                    <template v-if="isCurrentEmployerDirectorOrManager">
                        <el-badge :value="incomeCashlessMetric.new" class="menu-metric menu-badge" title="Новые" />
                        <el-badge :value="incomeCashlessMetric.toFix" class="menu-metric menu-badge" title="Исправить" />
                    </template>
                    <template v-if="isCurrentEmployerAccountant">
                        <el-badge :value="incomeCashlessMetric.onCheck" class="menu-metric menu-badge" title="На проверке" />
                    </template>
                </template>
            </template>
            <el-menu-item
                index="/finance/cash"
                v-if="canView('cash')"
                :class="['sub', { 'is-active-item': currentRouteName === 'cash'}]"
                @click="routeAndMobileMenuClose({ name:'cash' })"
            >
                <a :href="this.$router.resolve({ name:'cash' }).href">
                    <span>Кассы</span>
                </a>
            </el-menu-item>
            <el-submenu
                index="/finance/debts"
                v-if="canView('debts')"
                :class="{ 'is-active-item': nameSection === 'debts'}"
            >
                <template slot="title">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="file-invoice-dollar" class="menu-icon" />
                    </div>
                    <span class="submenu">
                        Долги
                    </span>
                </template>
                <el-menu-item
                    index="/finance/debts/employers"
                    v-if="canView('debts')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'debts-employers'}]"
                    @click="routeAndMobileMenuClose({ name:'debts-employers' })"
                >
                    <a :href="this.$router.resolve({ name:'debts-employers' }).href">
                        <span>Сотрудники</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/debts/contacts"
                    v-if="canView('debts')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'debts-contacts'}]"
                    @click="routeAndMobileMenuClose({ name:'debts-contacts' })"
                >
                    <a :href="this.$router.resolve({ name:'debts-contacts' }).href">
                        <span>Клиенты</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/debts/delivery"
                    v-if="canView('debts')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'debts-delivery'}]"
                    @click="routeAndMobileMenuClose({ name:'debts-delivery' })"
                >
                    <a :href="this.$router.resolve({ name:'debts-delivery' }).href">
                        <span>Доставка</span>
                    </a>
                </el-menu-item>
            </el-submenu>
            <el-submenu
                index="/finance/incomes"
                v-if="canView('incomes')"
                :class="{ 'is-active-item': nameSection === 'incomes'}"
            >
                <template slot="title">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="file-invoice-dollar" class="menu-icon" />
                    </div>
                    <span class="submenu">
                        Приходы
                    </span>
                    <template v-if="isShownIncomesMenuItemMetric">
                        <template v-if="isCurrentEmployerDirectorOrManager">
                            <el-badge :value="incomeCashlessMetric.new" class="menu-metric menu-badge" title="Новые" />
                            <el-badge :value="incomeCashlessMetric.toFix" class="menu-metric menu-badge" title="Исправить" />
                        </template>
                        <template v-if="isCurrentEmployerAccountant">
                            <el-badge :value="incomeCashlessMetric.onCheck" class="menu-metric menu-badge" title="На проверке" />
                        </template>
                    </template>
                </template>
                <el-menu-item
                    index="/finance/incomes/all"
                    v-if="canView('incomes')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'incomes-all'}]"
                    @click="routeAndMobileMenuClose({ name:'incomes-all' })"
                >
                    <a :href="this.$router.resolve({ name:'incomes-all' }).href">
                        <span>Все</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/incomes/cash"
                    v-if="canView('incomes')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'incomes-cash'}]"
                    @click="routeAndMobileMenuClose({ name:'incomes-cash' })"
                >
                    <a :href="this.$router.resolve({ name:'incomes-cash' }).href">
                        <span>@</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/incomes/cashless"
                    v-if="canView('incomes')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'incomes-cashless'}]"
                    @click="routeAndMobileMenuClose({ name:'incomes-cashless' })"
                >
                    <a :href="this.$router.resolve({ name:'incomes-cashless' }).href">
                        <span>Безнал</span>
                        <template v-if="isShownCashlessMenuItemMetric">
                            <template v-if="isCurrentEmployerDirectorOrManager">
                                <el-badge :value="incomeCashlessMetric.new" class="menu-metric menu-badge" title="Новые" />
                                <el-badge :value="incomeCashlessMetric.toFix" class="menu-metric menu-badge" title="Исправить" />
                            </template>
                            <template v-if="isCurrentEmployerAccountant">
                                <el-badge :value="incomeCashlessMetric.onCheck" class="menu-metric menu-badge" title="На проверке" />
                            </template>
                        </template>
                    </a>
                </el-menu-item>
            </el-submenu>
            <el-submenu
                index="/finance/salary"
                v-if="canView('expenses')"
                :class="{ 'is-active-item': nameSection === 'salary'}"
            >
                <template slot="title">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="file-invoice-dollar" class="menu-icon" />
                    </div>
                    <span class="submenu">
                        Зарплата
                    </span>
                </template>
                <el-menu-item
                    index="/finance/salary/payroll"
                    v-if="canView('expenses')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'salary-payroll'}]"
                    @click="routeAndMobileMenuClose({ name:'salary-payroll' })"
                >
                    <a :href="this.$router.resolve({ name:'salary-payroll' }).href">
                        <span>Ведомость</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/salary/payroll-info"
                    v-if="canView('expenses')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'salary-payroll-info'}]"
                    @click="routeAndMobileMenuClose({ name:'salary-payroll-info' })"
                >
                    <a :href="this.$router.resolve({ name:'salary-payroll-info' }).href">
                        <span>Начисления</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/salary/prepayment"
                    v-if="canView('expenses')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'salary-prepayment'}]"
                    @click="routeAndMobileMenuClose({ name:'salary-prepayment' })"
                >
                    <a :href="this.$router.resolve({ name:'salary-prepayment' }).href">
                        <span>Авансы</span>
                    </a>
                </el-menu-item>
            </el-submenu>
            <el-submenu
                index="/finance/expenses"
                v-if="canView('expenses')"
                :class="{ 'is-active-item': nameSection === 'expenses'}"
            >
                <template slot="title">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="file-invoice-dollar" class="menu-icon" />
                    </div>
                    <span class="submenu">
                        Расходы
                    </span>
                </template>
                <el-menu-item
                    index="/finance/expenses/deals"
                    v-if="canView('expenses')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'expenses-deals'}]"
                    @click="routeAndMobileMenuClose({ name:'expenses-deals' })"
                >
                    <a :href="this.$router.resolve({ name:'expenses-deals' }).href">
                        <span>Сделки</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/expenses/regular"
                    v-if="canView('expenses')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'expenses-regular'}]"
                    @click="routeAndMobileMenuClose({ name:'expenses-regular' })"
                >
                    <a :href="this.$router.resolve({ name:'expenses-regular' }).href">
                        <span>Постоянные</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/expenses/production"
                    v-if="canView('expenses')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'expenses-production'}]"
                    @click="routeAndMobileMenuClose({ name:'expenses-production' })"
                >
                    <a :href="this.$router.resolve({ name:'expenses-production' }).href">
                        <span>Производство</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/finance/expenses/registry_employers"
                    v-if="canView('expenses')"
                    :class="['sub', { 'is-active-item': currentRouteName === 'expenses-registry-employers'}]"
                    @click="routeAndMobileMenuClose({ name:'expenses-registry-employers' })"
                >
                    <a :href="this.$router.resolve({ name:'expenses-registry-employers' }).href">
                        <span>Реестр по сотрудникам</span>
                    </a>
                </el-menu-item>
            </el-submenu>
        </el-submenu>
        <el-menu-item
            index="/employers"
            v-if="canView('employers')"
            :class="['root-without-child','employers-li', { 'is-active-item': nameSection === 'employers'}]"
            @click="routeAndMobileMenuClose({ name:'employers' })"
        >
            <template slot="title">
                <a :href="this.$router.resolve({ name:'employers' }).href">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="user" class="menu-icon" />
                    </div>
                    <span>Сотрудники</span>
                </a>
            </template>
        </el-menu-item>
        <el-menu-item
            index="/measurement-map"
            v-if="canView('measurement_map')"
            :class="['root-without-child', { 'is-active-item': nameSection === 'measurement-map'}]"
            @click="routeAndMobileMenuClose({ name:'measurement-map' })"
        >
            <template slot="title">
                <a :href="this.$router.resolve({ name:'measurement-map' }).href">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="object-group" class="menu-icon" />
                    </div>
                    <span>Карта замеров</span>
                </a>
            </template>
        </el-menu-item>
        <el-menu-item
            index="/installation-map"
            v-if="canView('installation_map')"
            :class="['root-without-child', { 'is-active-item': nameSection === 'installation-map'}]"
            @click="routeAndMobileMenuClose({ name:'installation-map' })"
        >
            <template slot="title">
                <a :href="this.$router.resolve({ name:'installation-map' }).href">
                    <font-awesome-icon icon="object-group" class="menu-icon" />
                    <span>Карта монтажа</span>
                </a>
            </template>
        </el-menu-item>
        <el-submenu
            index="/logs"
            :route="{name:'logs'}"
            v-if="canView('logs')"
            :class="{ 'is-active-item': nameSection === 'logs'}"
        >
            <template slot="title">
                <div class="menu-icon-wrapper">
                    <font-awesome-icon icon="file-download" class="menu-icon" />
                </div>
                <span class="submenu">
                    Логи
                </span>
            </template>
            <el-menu-item
                index="/logs/system"
                v-if="canView('logs')"
                :class="['sub', { 'is-active-item': currentRouteName === 'system-log'}]"
                @click="routeAndMobileMenuClose({ name:'system-log' })"
            >
                <a :href="this.$router.resolve({ name:'system-log' }).href">
                    <span>Системный</span>
                </a>
            </el-menu-item>
            <el-menu-item
                index="/logs/leads"
                v-if="canView('logs')"
                :class="['sub', { 'is-active-item': currentRouteName === 'leads-log'}]"
                @click="routeAndMobileMenuClose({ name:'leads-log' })"
            >
                <a :href="this.$router.resolve({ name:'leads-log' }).href">
                    <span>Просмотр Лидов</span>
                </a>
            </el-menu-item>
            <el-menu-item
                index="/logs/sms"
                v-if="canView('logs')"
                :class="['sub', { 'is-active-item': currentRouteName === 'sms-log'}]"
                @click="routeAndMobileMenuClose({ name:'sms-log' })"
            >
                <a :href="this.$router.resolve({ name:'sms-log' }).href">
                    <span>СМС</span>
                </a>
            </el-menu-item>
        </el-submenu>
        <el-menu-item
            index="/settings"
            v-if="canView('settings')"
            :class="{ 'is-active-item': nameSection === 'settings'}"
            @click="routeAndMobileMenuClose({ name:'settings' })"
        >
            <template slot="title">
                <div class="menu-icon-wrapper">
                    <font-awesome-icon icon="cog" class="menu-icon" />
                </div>
                <span>Настройки</span>
            </template>
        </el-menu-item>
        <el-menu-item
            index="/timesheet"
            v-if="canView('timesheet')"
            :class="['root-without-child', { 'is-active-item': nameSection === 'timesheet'}]"
            @click="routeAndMobileMenuClose({ name:'timesheet' })"
        >
            <template slot="title">
                <a :href="this.$router.resolve({ name:'timesheet' }).href">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="cog" class="menu-icon" />
                    </div>
                    <span>Табель</span>
                </a>
            </template>
        </el-menu-item>
        <el-menu-item
            index="/calendar"
            v-if="canView('calendar')"
            :class="['root-without-child', { 'is-active-item': nameSection === 'calendar'}]"
            @click="routeAndMobileMenuClose({ name:'calendar' })"
        >
            <template slot="title">
                <a :href="this.$router.resolve({ name:'calendar' }).href">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="cog" class="menu-icon" />
                    </div>
                    <span>Календарь</span>
                </a>
            </template>
        </el-menu-item>
        <el-submenu
            index="/analytics"
            :route="{name:'analytics'}"
            v-if="canView('analytics')"
            :class="{ 'is-active-item': nameSection === 'analytics'}"
        >
            <template slot="title">
                <div class="menu-icon-wrapper">
                    <font-awesome-icon icon="file-download" class="menu-icon" />
                </div>
                <span class="submenu">
                    Аналитика
                </span>
            </template>
            <el-submenu
                index="/analytics/employers"
                :route="{name:'analytics'}"
                v-if="canView('analytics')"
                :class="{ 'is-active-item': nameSection === 'employers'}"
            >
                <template slot="title">
                    <div class="menu-icon-wrapper">
                        <font-awesome-icon icon="user" class="menu-icon" />
                    </div>
                    <span class="submenu">
                        Сотрудники
                    </span>
                </template>
                <el-menu-item
                    index="/analytics/employers/rating"
                    v-if="canView('analytics')"
                    :class="['sub','sub-2', { 'is-active-item': currentRouteName === 'analytics-employers-rating'}]"
                    @click="routeAndMobileMenuClose({ name:'analytics-employers-rating' })"
                >
                    <a :href="this.$router.resolve({ name:'analytics-employers-rating' }).href">
                        <span>Рейтинг</span>
                    </a>
                </el-menu-item>
                <el-menu-item
                    index="/analytics/employers/plan"
                    v-if="canView('analytics')"
                    :class="['sub','sub-2', { 'is-active-item': currentRouteName === 'analytics-employers-plan'}]"
                    @click="routeAndMobileMenuClose({ name:'analytics-employers-plan' })"
                >
                    <a :href="this.$router.resolve({ name:'analytics-employers-plan' }).href">
                        <span>План</span>
                    </a>
                </el-menu-item>
            </el-submenu>
            <el-menu-item
                index="/analytics/deal/deal-profit"
                v-if="canView('analytics')"
                :class="['sub','sub-2', { 'is-active-item': currentRouteName === 'analytics-deal-profit'}]"
                @click="routeAndMobileMenuClose({ name:'analytics-deal-profit' })"
            >
                <a :href="this.$router.resolve({ name:'analytics-deal-profit' }).href">
                    <span>Доходность сделки</span>
                </a>
            </el-menu-item>
        </el-submenu>
        <el-submenu
            index="/references"
            :route="{name:'references'}"
            v-if="canView('references')"
            :class="{ 'is-active-item': nameSection === 'references'}"
        >
            <template slot="title">
                <div class="menu-icon-wrapper">
                    <font-awesome-icon icon="book" class="menu-icon" />
                </div>
                <span class="submenu">
                    Справочники
                </span>
            </template>
            <el-menu-item
                index="/references/contractors"
                v-if="canView('references')"
                :class="['sub','sub-2', { 'is-active-item': currentRouteName === 'references-contractors'}]"
                @click="routeAndMobileMenuClose({ name:'references-contractors' })"
            >
                <a :href="this.$router.resolve({ name:'references-contractors' }).href">
                    <span>Контрагенты</span>
                </a>
            </el-menu-item>
        </el-submenu>
    </el-menu>
</template>

<script>
import { eventBus } from '@/common/eventBus';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTasks, faFileInvoiceDollar, faUser, faObjectGroup, faFileDownload, faCog, faBook } from '@fortawesome/free-solid-svg-icons';
import { faWindowMaximize } from '@fortawesome/free-regular-svg-icons';

library.add(faTasks, faWindowMaximize, faFileInvoiceDollar, faUser, faObjectGroup, faFileDownload, faCog, faBook);

export default {
    data: function() {
        return {
            defaultOpenedItems: ['/crm', '/tasks'],
            isShownTaskParentMenuItemMetric: false,
            isShownCashlessMenuItemMetric: true,
            isShownIncomesMenuItemMetric: false,
            isShownFinanceMenuItemMetric: true
        };
    },
    computed: {
        roles() {
            return this.$store.state.auth.roles;
        },
        sections() {
            return this.$store.getters.sectionsFromPermissions;
        },
        taskMetrics() {
            return this.$store.state.metrics.tasks;
        },
        leadMetric() {
            return this.$store.state.metrics.leads;
        },
        incomeCashlessMetric() {
            return this.$store.state.metrics.incomes.cashless;
        },
        nameSection() {
            return this.$route.path.split('/')[1];
        },
        nameSubSection() {
            return this.$route.path.split('/')[2];
        },
        currentRouteName() {
            return this.$route.name;
        },
        currentRoute() {
            return this.$route.path;
        },
        openedSubMenu() {
            const currentOpened = ['/' + this.nameSection];
            if (this.nameSection === 'analytics' && this.nameSubSection === 'employers') {
                currentOpened.push(currentOpened[0] + '/employers');
            }
            if (this.nameSection === 'finance') {
                switch (this.nameSubSection) {
                    case 'incomes':
                        currentOpened.push(currentOpened[0] + '/incomes');
                        break;
                    case 'debts':
                        currentOpened.push(currentOpened[0] + '/debts');
                        break;
                    case 'salary':
                        currentOpened.push(currentOpened[0] + '/salary');
                        break;
                    case 'expenses':
                        currentOpened.push(currentOpened[0] + '/expenses');
                        break;
                }
            }

            return [...new Set([...this.defaultOpenedItems, ...currentOpened])];
        },
        isCurrentEmployerDirectorOrManager() {
            return this.$store.getters.isCurrentEmployerDirector || this.$store.getters.isCurrentEmployerManager;
        },
        isCurrentEmployerAccountant() {
            return this.$store.getters.isCurrentEmployerAccountant;
        }
    },
    methods: {
        canView(section) {
            return this.sections.indexOf(section) !== -1;
        },
        handleOpen(key) {
            if (key === '/tasks') {
                this.isShownTaskParentMenuItemMetric = false;
            }
            if (key === '/finance') {
                this.isShownFinanceMenuItemMetric = false;
                this.isShownIncomesMenuItemMetric = true;
            }
            if (key === '/finance/incomes') {
                this.isShownIncomesMenuItemMetric = false;
                this.isShownCashlessMenuItemMetric = true;
            }
        },
        handleClose(key) {
            if (key === '/tasks') {
                this.isShownTaskParentMenuItemMetric = true;
            }
            if (key === '/finance') {
                this.isShownFinanceMenuItemMetric = true;
                this.isShownIncomesMenuItemMetric = false;
                this.isShownCashlessMenuItemMetric = false;
            }
            if (key === '/finance/incomes') {
                this.isShownIncomesMenuItemMetric = true;
                this.isShownCashlessMenuItemMetric = false;
            }
        },
        //если мобильное меню закрывать при клике по пунктам в подменю
        routeAndMobileMenuClose(name) {
            if (window.innerWidth < this.$root.desktopWidth) {
                eventBus.$emit('close-mobile-menu');
            }
        }
    },
    watch: {
        currentRouteName(value) {
            if (value === 'tasks-all') {
                this.openedSubMenu.push('/tasks');
                this.isShownTaskParentMenuItemMetric = false;
            }
            if (this.openedSubMenu.includes('/tasks')) {
                this.isShownTaskParentMenuItemMetric = false;
            }
            if (this.openedSubMenu.includes('/finance')) {
                if (this.openedSubMenu.includes('/finance/incomes')) {
                    this.isShownFinanceMenuItemMetric = false;
                    this.isShownIncomesMenuItemMetric = false;
                } else {
                    this.isShownFinanceMenuItemMetric = false;
                    this.isShownIncomesMenuItemMetric = true;
                }
            } else {
                this.isShownFinanceMenuItemMetric = true;
                this.isShownIncomesMenuItemMetric = false;
            }
        }
    }
};
</script>
